exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contentContainer-3ILGv{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.checkbox-PyhqB{margin-bottom:20px}.container-1zt9H{border:#042b75;background-color:#042b75;padding:20px}.container-1zt9H:not(:last-child){margin-bottom:20px}.title-10rza{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"contentContainer": "contentContainer-3ILGv",
	"checkbox": "checkbox-PyhqB",
	"container": "container-1zt9H",
	"title": "title-10rza"
};